// ============================================================================
// COMPLIANCE CALENDAR SERVICE
// ============================================================================

import { get } from '../client/axiosClient';
import { buildEndpoint, buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ComplianceObligation,
  ComplianceCalendarQuery,
} from '../types/complianceCalendar.types';

const BASE_PATH = '/ComplianceCalendar';

class ComplianceCalendarService {
  /**
   * Everything due in the window, across every compliance module.
   *
   * Not paginated, deliberately: a month of deadlines for one firm is a
   * bounded set, and the screen groups and sub-totals it — both of which need
   * the whole window, not a page of it.
   */
  async getCalendar(query: ComplianceCalendarQuery): Promise<ComplianceObligation[]> {
    const endpoint = buildEndpointWithQuery(BASE_PATH, query as Record<string, any>);
    const response = await get<any>(endpoint);
    return (response.data?.data ?? []) as ComplianceObligation[];
  }

  /**
   * Obligations with no deadline at all. They cannot appear on a calendar of
   * deadlines, so the screen shows the count rather than letting them vanish.
   */
  async getUndatedCount(moduleCode?: string): Promise<number> {
    const endpoint = moduleCode
      ? buildEndpointWithQuery(`${BASE_PATH}/undated-count`, { moduleCode })
      : buildEndpoint(`${BASE_PATH}/undated-count`);
    const response = await get<any>(endpoint);
    return (response.data?.data ?? 0) as number;
  }
}

export const complianceCalendarService = new ComplianceCalendarService();
export default complianceCalendarService;
